import Immutable from 'seamless-immutable';
import _ from 'lodash';

const REQUEST_IN_PROGRESS = 'REQUEST_IN_PROGRESS';
const REQUEST_FINISHED = 'REQUEST_FINISHED';
const SEND_REQUEST = 'SEND_REQUEST';
const UPDATE_DATA = 'UPDATE_DATA';
const INIT_STATE = 'INIT_STATE';

const createActionName = (reducerName, name) => `app/${reducerName}/${name}`;
export const getState = (state, reducerName) => _.get(state, reducerName);

const createReducer = parentName => {
  function stateDefault() {
    return {
      identifier: null,
      requestState: {
        inProgress: false,
        lastStatusCode: null,
        countQueries: 0
      },
      data: {}
    };
  }

  const initialState = Immutable(stateDefault());
  return function reduce(state = initialState, action = {}) {
    switch (action.type) {
      case createActionName(parentName, REQUEST_IN_PROGRESS):
        return state.merge({
          requestState: {
            inProgress: true,
            lastStatusCode: null
          }
        });
      case createActionName(parentName, REQUEST_FINISHED):
        return state.merge({
          requestState: {
            inProgress: false,
            lastStatusCode: action.payload,
            countQueries: state.countQueries + 1
          }
        });
      case createActionName(parentName, SEND_REQUEST):
        return state.merge({
          identifier: action.payload
        });
      case createActionName(parentName, UPDATE_DATA):
        return state.merge({
          data: action.payload
        });
      case createActionName(parentName, INIT_STATE):
        return initialState;
      default:
        return state;
    }
  };
};

export function createReduceObject(combineName, reducerName) {
  const reduceObject = {};
  reduceObject[reducerName] = createReducer(`${combineName}.${reducerName}`);
  return reduceObject;
}

// ACTIONS CREATOR
export const requestInProcess = parentName => ({
  type: createActionName(parentName, REQUEST_IN_PROGRESS)
});
export const requestFinished = (parentName, payload) => ({
  type: createActionName(parentName, REQUEST_FINISHED),
  payload
});
export const sendRequest = (parentName, payload) => ({
  type: createActionName(parentName, SEND_REQUEST),
  payload
});
export const updateData = (parentName, payload) => ({
  type: createActionName(parentName, UPDATE_DATA),
  payload
});
export const initState = parentName => ({
  type: createActionName(parentName, INIT_STATE)
});

// SELECTORS
export const selectRequestState = (state, parentName) =>
  getState(state, parentName).requestState;
export const selectIdentifier = (state, parentName) =>
  getState(state, parentName).identifier;
export const selectData = (state, parentName) =>
  getState(state, parentName).data;



// WEBPACK FOOTER //
// ./src/mt-react-common/common/reducers/data/reducer.js